module.exports = __webpack_public_path__ + "site/img/ttq2.f74bc69.png";


//////////////////
// WEBPACK FOOTER
// ./site/ttq2.png
// module id = 138
// module chunks = 1